import { useEffect, useState } from 'react';
import { useStore } from 'src/contexts/StoreContext';
import { SAVING_STATE } from 'src/store/page-project/pageProject.constants';

export const useSaveButtonDesktopLogic = () => {
  const { i18n, project } = useStore();

  const [saveButtonText, setSaveButtonText] = useState<string>('');
  const [saveButtonTextVisible, setSaveButtonTextVisible] = useState<boolean>(false);

  useEffect(() => {
    const SaveButtonTexts = {
      [SAVING_STATE.saving]: '',
      [SAVING_STATE.uploading]: '',
      [SAVING_STATE.saved]: i18n.t('header:saved'),
      [SAVING_STATE.toBeSaved]: i18n.t('header:save'),
    };
    setSaveButtonText(SaveButtonTexts[project.activeProject!.savingState]);

    if (project.activeProject!.savingState !== SAVING_STATE.saving) {
      setSaveButtonTextVisible(true);
    }
    if (project.activeProject!.savingState === SAVING_STATE.saved) {
      setTimeout(() => {
        setSaveButtonTextVisible(false);
      }, 2000);
    }
  }, [project.activeProject!.savingState]);

  return {
    saveButtonText,
    saveButtonTextVisible,
  };
};
